import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { SortOrderEnum } from '@/lib/types';

import { DropdownBase, type OnChangeValue } from '@/primitives';

import { dropdownSortOrderMessages } from './messages';

export type SortOrderOption = {
  label: string;
  value: SortOrderEnum;
};

export interface DropdownSortOrderProps {
  onChange?: (value: SortOrderEnum | undefined) => void;
  value?: SortOrderEnum | undefined;
}

export function DropdownSortOrder({ onChange, value }: DropdownSortOrderProps) {
  const intl = useIntl();

  const options = useMemo(() => {
    return [
      {
        label: intl.formatMessage(
          dropdownSortOrderMessages['dropdownSortOrder.ascending'].props,
        ),
        value: SortOrderEnum.ASC,
      },
      {
        label: intl.formatMessage(
          dropdownSortOrderMessages['dropdownSortOrder.descending'].props,
        ),
        value: SortOrderEnum.DESC,
      },
    ];
  }, [intl]);

  const valueOption = useMemo(() => {
    return options.find((option) => option.value === value);
  }, [options, value]);

  const handleChange = (value: OnChangeValue<SortOrderOption, false>) => {
    if (onChange) {
      onChange(value?.value);
    }
  };

  return (
    <DropdownBase
      label={dropdownSortOrderMessages['dropdownSortOrder.label']}
      isMulti={false}
      isSearchable={false}
      onChange={handleChange}
      options={options}
      value={valueOption}
    />
  );
}
